// Link from an admin row to the article's page on the member-facing site.
//
// The reader app is what the publish/unpublish switch actually controls,
// so this is the page that reflects an article's status. (The legacy
// membership.* WordPress sites in `wp_url` are unaffected by it.)
//
// `base` is the title's public origin from usePublicBaseUrls() — www.* on
// production, next.* on dev. Never hardcode a host here: a fixed next.* map
// sent production's admin to the dev site (2026-10-13).
//
// Returns null rather than guessing: an article with no slug has no URL to
// build, and with no base (unknown title, /api/me still loading) any host
// would be a guess — a wrong page is worse than no link.

export function memberArticleUrl(
  base: string | null | undefined, slug: string | null | undefined,
): string | null {
  if (!base || !slug) return null
  return `${base}/articles/${encodeURIComponent(slug)}`
}

// Digital editions are addressed by their numeric edition id, not a slug:
// `/digital-editions/<id>`. The API already serves that path as
// `viewer_url`, so it is passed through rather than rebuilt here — the
// path shape stays owned by the backend that writes it.
export function memberIssueUrl(
  base: string | null | undefined, viewerUrl: string | null | undefined,
): string | null {
  if (!base || !viewerUrl) return null
  return `${base}${viewerUrl}`
}
